/**
 * Generated by orval v8.7.0 🍺
 * Do not edit manually.
 * Agentiq.Api | v1
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CompiledWorkflowSnapshotDto,
  DeleteApiWorkflowPoliciesWorkflowKeyParams,
  GetApiWorkflowPoliciesParams,
  GetApiWorkflowPoliciesWorkflowKeyParams,
  GetExecutionRequest,
  ListExecutionsRequest,
  RuntimeSnapshotApplyResponseDto,
  SaveWorkflowPolicyRequest,
  SnapshotApplyRequest,
  SnapshotCompileRequest,
  WorkflowDefinitionDto,
  WorkflowRunRequest
} from '../control-api.schemas';

import { orvalControlFetch } from '../../orval-fetcher';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getPostApiSnapshotApplyUrl = () => {




  return `/api/snapshot/apply`
}

export const postApiSnapshotApply = async (snapshotApplyRequest: SnapshotApplyRequest, options?: RequestInit): Promise<RuntimeSnapshotApplyResponseDto> => {

  return orvalControlFetch<RuntimeSnapshotApplyResponseDto>(getPostApiSnapshotApplyUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      snapshotApplyRequest,)
  }
);}




export const getPostApiSnapshotApplyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiSnapshotApply>>, TError,{data: SnapshotApplyRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiSnapshotApply>>, TError,{data: SnapshotApplyRequest}, TContext> => {

const mutationKey = ['postApiSnapshotApply'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiSnapshotApply>>, {data: SnapshotApplyRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiSnapshotApply(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiSnapshotApplyMutationResult = NonNullable<Awaited<ReturnType<typeof postApiSnapshotApply>>>
    export type PostApiSnapshotApplyMutationBody = SnapshotApplyRequest
    export type PostApiSnapshotApplyMutationError = unknown

    export const usePostApiSnapshotApply = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiSnapshotApply>>, TError,{data: SnapshotApplyRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiSnapshotApply>>,
        TError,
        {data: SnapshotApplyRequest},
        TContext
      > => {
      return useMutation(getPostApiSnapshotApplyMutationOptions(options), queryClient);
    }
    export const getPostApiSnapshotCompileUrl = () => {




  return `/api/snapshot/compile`
}

export const postApiSnapshotCompile = async (snapshotCompileRequest: SnapshotCompileRequest, options?: RequestInit): Promise<CompiledWorkflowSnapshotDto> => {

  return orvalControlFetch<CompiledWorkflowSnapshotDto>(getPostApiSnapshotCompileUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      snapshotCompileRequest,)
  }
);}




export const getPostApiSnapshotCompileMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiSnapshotCompile>>, TError,{data: SnapshotCompileRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiSnapshotCompile>>, TError,{data: SnapshotCompileRequest}, TContext> => {

const mutationKey = ['postApiSnapshotCompile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiSnapshotCompile>>, {data: SnapshotCompileRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiSnapshotCompile(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiSnapshotCompileMutationResult = NonNullable<Awaited<ReturnType<typeof postApiSnapshotCompile>>>
    export type PostApiSnapshotCompileMutationBody = SnapshotCompileRequest
    export type PostApiSnapshotCompileMutationError = unknown

    export const usePostApiSnapshotCompile = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiSnapshotCompile>>, TError,{data: SnapshotCompileRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiSnapshotCompile>>,
        TError,
        {data: SnapshotCompileRequest},
        TContext
      > => {
      return useMutation(getPostApiSnapshotCompileMutationOptions(options), queryClient);
    }
    export const getPostApiWorkflowRunUrl = () => {




  return `/api/workflow/run`
}

export const postApiWorkflowRun = async (workflowRunRequest: WorkflowRunRequest, options?: RequestInit): Promise<void> => {

  return orvalControlFetch<void>(getPostApiWorkflowRunUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      workflowRunRequest,)
  }
);}




export const getPostApiWorkflowRunMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiWorkflowRun>>, TError,{data: WorkflowRunRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiWorkflowRun>>, TError,{data: WorkflowRunRequest}, TContext> => {

const mutationKey = ['postApiWorkflowRun'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiWorkflowRun>>, {data: WorkflowRunRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiWorkflowRun(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiWorkflowRunMutationResult = NonNullable<Awaited<ReturnType<typeof postApiWorkflowRun>>>
    export type PostApiWorkflowRunMutationBody = WorkflowRunRequest
    export type PostApiWorkflowRunMutationError = unknown

    export const usePostApiWorkflowRun = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiWorkflowRun>>, TError,{data: WorkflowRunRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiWorkflowRun>>,
        TError,
        {data: WorkflowRunRequest},
        TContext
      > => {
      return useMutation(getPostApiWorkflowRunMutationOptions(options), queryClient);
    }
    export const getPostApiExecutionsUrl = () => {




  return `/api/executions`
}

export const postApiExecutions = async (listExecutionsRequestNull: ListExecutionsRequest | null, options?: RequestInit): Promise<void> => {

  return orvalControlFetch<void>(getPostApiExecutionsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      listExecutionsRequestNull,)
  }
);}




export const getPostApiExecutionsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiExecutions>>, TError,{data: ListExecutionsRequest | null}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiExecutions>>, TError,{data: ListExecutionsRequest | null}, TContext> => {

const mutationKey = ['postApiExecutions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiExecutions>>, {data: ListExecutionsRequest | null}> = (props) => {
          const {data} = props ?? {};

          return  postApiExecutions(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiExecutionsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiExecutions>>>
    export type PostApiExecutionsMutationBody = ListExecutionsRequest | null
    export type PostApiExecutionsMutationError = unknown

    export const usePostApiExecutions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiExecutions>>, TError,{data: ListExecutionsRequest | null}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiExecutions>>,
        TError,
        {data: ListExecutionsRequest | null},
        TContext
      > => {
      return useMutation(getPostApiExecutionsMutationOptions(options), queryClient);
    }
    export const getPostApiExecutionUrl = () => {




  return `/api/execution`
}

export const postApiExecution = async (getExecutionRequest: GetExecutionRequest, options?: RequestInit): Promise<void> => {

  return orvalControlFetch<void>(getPostApiExecutionUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      getExecutionRequest,)
  }
);}




export const getPostApiExecutionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiExecution>>, TError,{data: GetExecutionRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiExecution>>, TError,{data: GetExecutionRequest}, TContext> => {

const mutationKey = ['postApiExecution'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiExecution>>, {data: GetExecutionRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiExecution(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiExecutionMutationResult = NonNullable<Awaited<ReturnType<typeof postApiExecution>>>
    export type PostApiExecutionMutationBody = GetExecutionRequest
    export type PostApiExecutionMutationError = unknown

    export const usePostApiExecution = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiExecution>>, TError,{data: GetExecutionRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiExecution>>,
        TError,
        {data: GetExecutionRequest},
        TContext
      > => {
      return useMutation(getPostApiExecutionMutationOptions(options), queryClient);
    }
    export const getGetApiWorkflowDefinitionsUrl = () => {




  return `/api/workflow-definitions`
}

export const getApiWorkflowDefinitions = async ( options?: RequestInit): Promise<void> => {

  return orvalControlFetch<void>(getGetApiWorkflowDefinitionsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetApiWorkflowDefinitionsQueryKey = () => {
    return [
    `/api/workflow-definitions`
    ] as const;
    }


export const getGetApiWorkflowDefinitionsQueryOptions = <TData = Awaited<ReturnType<typeof getApiWorkflowDefinitions>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWorkflowDefinitions>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiWorkflowDefinitionsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiWorkflowDefinitions>>> = ({ signal }) => getApiWorkflowDefinitions({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiWorkflowDefinitions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiWorkflowDefinitionsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiWorkflowDefinitions>>>
export type GetApiWorkflowDefinitionsQueryError = unknown


export function useGetApiWorkflowDefinitions<TData = Awaited<ReturnType<typeof getApiWorkflowDefinitions>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWorkflowDefinitions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiWorkflowDefinitions>>,
          TError,
          Awaited<ReturnType<typeof getApiWorkflowDefinitions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiWorkflowDefinitions<TData = Awaited<ReturnType<typeof getApiWorkflowDefinitions>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWorkflowDefinitions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiWorkflowDefinitions>>,
          TError,
          Awaited<ReturnType<typeof getApiWorkflowDefinitions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiWorkflowDefinitions<TData = Awaited<ReturnType<typeof getApiWorkflowDefinitions>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWorkflowDefinitions>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiWorkflowDefinitions<TData = Awaited<ReturnType<typeof getApiWorkflowDefinitions>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWorkflowDefinitions>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiWorkflowDefinitionsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getPostApiWorkflowDefinitionsUrl = () => {




  return `/api/workflow-definitions`
}

export const postApiWorkflowDefinitions = async (workflowDefinitionDto: WorkflowDefinitionDto, options?: RequestInit): Promise<void> => {

  return orvalControlFetch<void>(getPostApiWorkflowDefinitionsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      workflowDefinitionDto,)
  }
);}




export const getPostApiWorkflowDefinitionsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiWorkflowDefinitions>>, TError,{data: WorkflowDefinitionDto}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiWorkflowDefinitions>>, TError,{data: WorkflowDefinitionDto}, TContext> => {

const mutationKey = ['postApiWorkflowDefinitions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiWorkflowDefinitions>>, {data: WorkflowDefinitionDto}> = (props) => {
          const {data} = props ?? {};

          return  postApiWorkflowDefinitions(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiWorkflowDefinitionsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiWorkflowDefinitions>>>
    export type PostApiWorkflowDefinitionsMutationBody = WorkflowDefinitionDto
    export type PostApiWorkflowDefinitionsMutationError = unknown

    export const usePostApiWorkflowDefinitions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiWorkflowDefinitions>>, TError,{data: WorkflowDefinitionDto}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiWorkflowDefinitions>>,
        TError,
        {data: WorkflowDefinitionDto},
        TContext
      > => {
      return useMutation(getPostApiWorkflowDefinitionsMutationOptions(options), queryClient);
    }
    export const getGetApiWorkflowDefinitionsWorkflowKeyUrl = (workflowKey: string,) => {




  return `/api/workflow-definitions/${workflowKey}`
}

export const getApiWorkflowDefinitionsWorkflowKey = async (workflowKey: string, options?: RequestInit): Promise<void> => {

  return orvalControlFetch<void>(getGetApiWorkflowDefinitionsWorkflowKeyUrl(workflowKey),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetApiWorkflowDefinitionsWorkflowKeyQueryKey = (workflowKey: string,) => {
    return [
    `/api/workflow-definitions/${workflowKey}`
    ] as const;
    }


export const getGetApiWorkflowDefinitionsWorkflowKeyQueryOptions = <TData = Awaited<ReturnType<typeof getApiWorkflowDefinitionsWorkflowKey>>, TError = unknown>(workflowKey: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWorkflowDefinitionsWorkflowKey>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiWorkflowDefinitionsWorkflowKeyQueryKey(workflowKey);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiWorkflowDefinitionsWorkflowKey>>> = ({ signal }) => getApiWorkflowDefinitionsWorkflowKey(workflowKey, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(workflowKey), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiWorkflowDefinitionsWorkflowKey>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiWorkflowDefinitionsWorkflowKeyQueryResult = NonNullable<Awaited<ReturnType<typeof getApiWorkflowDefinitionsWorkflowKey>>>
export type GetApiWorkflowDefinitionsWorkflowKeyQueryError = unknown


export function useGetApiWorkflowDefinitionsWorkflowKey<TData = Awaited<ReturnType<typeof getApiWorkflowDefinitionsWorkflowKey>>, TError = unknown>(
 workflowKey: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWorkflowDefinitionsWorkflowKey>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiWorkflowDefinitionsWorkflowKey>>,
          TError,
          Awaited<ReturnType<typeof getApiWorkflowDefinitionsWorkflowKey>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiWorkflowDefinitionsWorkflowKey<TData = Awaited<ReturnType<typeof getApiWorkflowDefinitionsWorkflowKey>>, TError = unknown>(
 workflowKey: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWorkflowDefinitionsWorkflowKey>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiWorkflowDefinitionsWorkflowKey>>,
          TError,
          Awaited<ReturnType<typeof getApiWorkflowDefinitionsWorkflowKey>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiWorkflowDefinitionsWorkflowKey<TData = Awaited<ReturnType<typeof getApiWorkflowDefinitionsWorkflowKey>>, TError = unknown>(
 workflowKey: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWorkflowDefinitionsWorkflowKey>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiWorkflowDefinitionsWorkflowKey<TData = Awaited<ReturnType<typeof getApiWorkflowDefinitionsWorkflowKey>>, TError = unknown>(
 workflowKey: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWorkflowDefinitionsWorkflowKey>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiWorkflowDefinitionsWorkflowKeyQueryOptions(workflowKey,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getDeleteApiWorkflowDefinitionsWorkflowKeyUrl = (workflowKey: string,) => {




  return `/api/workflow-definitions/${workflowKey}`
}

export const deleteApiWorkflowDefinitionsWorkflowKey = async (workflowKey: string, options?: RequestInit): Promise<void> => {

  return orvalControlFetch<void>(getDeleteApiWorkflowDefinitionsWorkflowKeyUrl(workflowKey),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteApiWorkflowDefinitionsWorkflowKeyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiWorkflowDefinitionsWorkflowKey>>, TError,{workflowKey: string}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiWorkflowDefinitionsWorkflowKey>>, TError,{workflowKey: string}, TContext> => {

const mutationKey = ['deleteApiWorkflowDefinitionsWorkflowKey'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiWorkflowDefinitionsWorkflowKey>>, {workflowKey: string}> = (props) => {
          const {workflowKey} = props ?? {};

          return  deleteApiWorkflowDefinitionsWorkflowKey(workflowKey,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiWorkflowDefinitionsWorkflowKeyMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiWorkflowDefinitionsWorkflowKey>>>

    export type DeleteApiWorkflowDefinitionsWorkflowKeyMutationError = unknown

    export const useDeleteApiWorkflowDefinitionsWorkflowKey = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiWorkflowDefinitionsWorkflowKey>>, TError,{workflowKey: string}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiWorkflowDefinitionsWorkflowKey>>,
        TError,
        {workflowKey: string},
        TContext
      > => {
      return useMutation(getDeleteApiWorkflowDefinitionsWorkflowKeyMutationOptions(options), queryClient);
    }
    export const getGetApiWorkflowPoliciesUrl = (params?: GetApiWorkflowPoliciesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/workflow-policies?${stringifiedParams}` : `/api/workflow-policies`
}

export const getApiWorkflowPolicies = async (params?: GetApiWorkflowPoliciesParams, options?: RequestInit): Promise<void> => {

  return orvalControlFetch<void>(getGetApiWorkflowPoliciesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetApiWorkflowPoliciesQueryKey = (params?: GetApiWorkflowPoliciesParams,) => {
    return [
    `/api/workflow-policies`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiWorkflowPoliciesQueryOptions = <TData = Awaited<ReturnType<typeof getApiWorkflowPolicies>>, TError = unknown>(params?: GetApiWorkflowPoliciesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWorkflowPolicies>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiWorkflowPoliciesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiWorkflowPolicies>>> = ({ signal }) => getApiWorkflowPolicies(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiWorkflowPolicies>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiWorkflowPoliciesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiWorkflowPolicies>>>
export type GetApiWorkflowPoliciesQueryError = unknown


export function useGetApiWorkflowPolicies<TData = Awaited<ReturnType<typeof getApiWorkflowPolicies>>, TError = unknown>(
 params: undefined |  GetApiWorkflowPoliciesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWorkflowPolicies>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiWorkflowPolicies>>,
          TError,
          Awaited<ReturnType<typeof getApiWorkflowPolicies>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiWorkflowPolicies<TData = Awaited<ReturnType<typeof getApiWorkflowPolicies>>, TError = unknown>(
 params?: GetApiWorkflowPoliciesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWorkflowPolicies>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiWorkflowPolicies>>,
          TError,
          Awaited<ReturnType<typeof getApiWorkflowPolicies>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiWorkflowPolicies<TData = Awaited<ReturnType<typeof getApiWorkflowPolicies>>, TError = unknown>(
 params?: GetApiWorkflowPoliciesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWorkflowPolicies>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiWorkflowPolicies<TData = Awaited<ReturnType<typeof getApiWorkflowPolicies>>, TError = unknown>(
 params?: GetApiWorkflowPoliciesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWorkflowPolicies>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiWorkflowPoliciesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getPostApiWorkflowPoliciesUrl = () => {




  return `/api/workflow-policies`
}

export const postApiWorkflowPolicies = async (saveWorkflowPolicyRequest: SaveWorkflowPolicyRequest, options?: RequestInit): Promise<void> => {

  return orvalControlFetch<void>(getPostApiWorkflowPoliciesUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      saveWorkflowPolicyRequest,)
  }
);}




export const getPostApiWorkflowPoliciesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiWorkflowPolicies>>, TError,{data: SaveWorkflowPolicyRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiWorkflowPolicies>>, TError,{data: SaveWorkflowPolicyRequest}, TContext> => {

const mutationKey = ['postApiWorkflowPolicies'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiWorkflowPolicies>>, {data: SaveWorkflowPolicyRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiWorkflowPolicies(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiWorkflowPoliciesMutationResult = NonNullable<Awaited<ReturnType<typeof postApiWorkflowPolicies>>>
    export type PostApiWorkflowPoliciesMutationBody = SaveWorkflowPolicyRequest
    export type PostApiWorkflowPoliciesMutationError = unknown

    export const usePostApiWorkflowPolicies = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiWorkflowPolicies>>, TError,{data: SaveWorkflowPolicyRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiWorkflowPolicies>>,
        TError,
        {data: SaveWorkflowPolicyRequest},
        TContext
      > => {
      return useMutation(getPostApiWorkflowPoliciesMutationOptions(options), queryClient);
    }
    export const getGetApiWorkflowPoliciesWorkflowKeyUrl = (workflowKey: string,
    params?: GetApiWorkflowPoliciesWorkflowKeyParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/workflow-policies/${workflowKey}?${stringifiedParams}` : `/api/workflow-policies/${workflowKey}`
}

export const getApiWorkflowPoliciesWorkflowKey = async (workflowKey: string,
    params?: GetApiWorkflowPoliciesWorkflowKeyParams, options?: RequestInit): Promise<void> => {

  return orvalControlFetch<void>(getGetApiWorkflowPoliciesWorkflowKeyUrl(workflowKey,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetApiWorkflowPoliciesWorkflowKeyQueryKey = (workflowKey: string,
    params?: GetApiWorkflowPoliciesWorkflowKeyParams,) => {
    return [
    `/api/workflow-policies/${workflowKey}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiWorkflowPoliciesWorkflowKeyQueryOptions = <TData = Awaited<ReturnType<typeof getApiWorkflowPoliciesWorkflowKey>>, TError = unknown>(workflowKey: string,
    params?: GetApiWorkflowPoliciesWorkflowKeyParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWorkflowPoliciesWorkflowKey>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiWorkflowPoliciesWorkflowKeyQueryKey(workflowKey,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiWorkflowPoliciesWorkflowKey>>> = ({ signal }) => getApiWorkflowPoliciesWorkflowKey(workflowKey,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(workflowKey), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiWorkflowPoliciesWorkflowKey>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiWorkflowPoliciesWorkflowKeyQueryResult = NonNullable<Awaited<ReturnType<typeof getApiWorkflowPoliciesWorkflowKey>>>
export type GetApiWorkflowPoliciesWorkflowKeyQueryError = unknown


export function useGetApiWorkflowPoliciesWorkflowKey<TData = Awaited<ReturnType<typeof getApiWorkflowPoliciesWorkflowKey>>, TError = unknown>(
 workflowKey: string,
    params: undefined |  GetApiWorkflowPoliciesWorkflowKeyParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWorkflowPoliciesWorkflowKey>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiWorkflowPoliciesWorkflowKey>>,
          TError,
          Awaited<ReturnType<typeof getApiWorkflowPoliciesWorkflowKey>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiWorkflowPoliciesWorkflowKey<TData = Awaited<ReturnType<typeof getApiWorkflowPoliciesWorkflowKey>>, TError = unknown>(
 workflowKey: string,
    params?: GetApiWorkflowPoliciesWorkflowKeyParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWorkflowPoliciesWorkflowKey>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiWorkflowPoliciesWorkflowKey>>,
          TError,
          Awaited<ReturnType<typeof getApiWorkflowPoliciesWorkflowKey>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiWorkflowPoliciesWorkflowKey<TData = Awaited<ReturnType<typeof getApiWorkflowPoliciesWorkflowKey>>, TError = unknown>(
 workflowKey: string,
    params?: GetApiWorkflowPoliciesWorkflowKeyParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWorkflowPoliciesWorkflowKey>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiWorkflowPoliciesWorkflowKey<TData = Awaited<ReturnType<typeof getApiWorkflowPoliciesWorkflowKey>>, TError = unknown>(
 workflowKey: string,
    params?: GetApiWorkflowPoliciesWorkflowKeyParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWorkflowPoliciesWorkflowKey>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiWorkflowPoliciesWorkflowKeyQueryOptions(workflowKey,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getDeleteApiWorkflowPoliciesWorkflowKeyUrl = (workflowKey: string,
    params?: DeleteApiWorkflowPoliciesWorkflowKeyParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/workflow-policies/${workflowKey}?${stringifiedParams}` : `/api/workflow-policies/${workflowKey}`
}

export const deleteApiWorkflowPoliciesWorkflowKey = async (workflowKey: string,
    params?: DeleteApiWorkflowPoliciesWorkflowKeyParams, options?: RequestInit): Promise<void> => {

  return orvalControlFetch<void>(getDeleteApiWorkflowPoliciesWorkflowKeyUrl(workflowKey,params),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteApiWorkflowPoliciesWorkflowKeyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiWorkflowPoliciesWorkflowKey>>, TError,{workflowKey: string;params?: DeleteApiWorkflowPoliciesWorkflowKeyParams}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiWorkflowPoliciesWorkflowKey>>, TError,{workflowKey: string;params?: DeleteApiWorkflowPoliciesWorkflowKeyParams}, TContext> => {

const mutationKey = ['deleteApiWorkflowPoliciesWorkflowKey'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiWorkflowPoliciesWorkflowKey>>, {workflowKey: string;params?: DeleteApiWorkflowPoliciesWorkflowKeyParams}> = (props) => {
          const {workflowKey,params} = props ?? {};

          return  deleteApiWorkflowPoliciesWorkflowKey(workflowKey,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiWorkflowPoliciesWorkflowKeyMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiWorkflowPoliciesWorkflowKey>>>

    export type DeleteApiWorkflowPoliciesWorkflowKeyMutationError = unknown

    export const useDeleteApiWorkflowPoliciesWorkflowKey = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiWorkflowPoliciesWorkflowKey>>, TError,{workflowKey: string;params?: DeleteApiWorkflowPoliciesWorkflowKeyParams}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiWorkflowPoliciesWorkflowKey>>,
        TError,
        {workflowKey: string;params?: DeleteApiWorkflowPoliciesWorkflowKeyParams},
        TContext
      > => {
      return useMutation(getDeleteApiWorkflowPoliciesWorkflowKeyMutationOptions(options), queryClient);
    }
